// TheParentDashboard.js
import React, { useContext, useEffect, useState } from "react";
import "./Components/TheParentDashboard.css";
import ParentStarting from "./Components/ParentStarting";
import StudentDetails from "./Components/StudentDetails";
import { MainContext } from "../../../../../context/main/main-context";

export default function TheParentDashboard({StudentParentList,grades}) {


  const {
    parent_dashboard_initial_loading,
    parent_dashboard_data_loading,
    parent_dashboard_data,
    fetchParentDashboardData
  } = useContext(MainContext)

  const [allRecentAnnouncements, setAllRecentAnnouncements] = useState([]);
  const [weeklyAnnouncements, setWeeklyAnnouncements] = useState([]);
  const [monthlyAnnouncements, setMonthlyAnnouncements] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [availablePapers, setAvailablePapers] = useState([]);

  useEffect(() => {
    if (StudentParentList?.students?.length > 0) {
      const ids = StudentParentList.students.map(s => s.stu_id);
      fetchParentDashboardData(ids);
    }
  }, [StudentParentList]);

  useEffect(() => {

    if (parent_dashboard_data && parent_dashboard_data.success && parent_dashboard_data.data) {

      const announcements = parent_dashboard_data.data.announcement_data;
      const availablePapersData = parent_dashboard_data.data.available_papers;

      const enrolledPaperData = parent_dashboard_data.data.student_enrolled_papers;

      setAllRecentAnnouncements(announcements.all_recent_announcement || []);
      setWeeklyAnnouncements(announcements.weekly_announcement || []);
      setMonthlyAnnouncements(announcements.monthly_announcement || []);

      setAvailablePapers(availablePapersData || [])

      const updatedStudents = StudentParentList?.students?.map(student => {
        const studentEnrolled = enrolledPaperData?.find(
          e => e.student_id === student.stu_id
        );

          return {
            ...student,
            enrolled_papers: studentEnrolled?.enrolled_papers || [],
            available_credits_count: studentEnrolled?.available_credit_count || 0
          };
        });

      setStudentData(updatedStudents)

    }

  }, [parent_dashboard_data])
  
  
  return (
    <div className="parent-dashboard py-3">
      <div className="row">
        <div className="col-lg-3 col-12 mb-4">
          <ParentStarting
            allRecentAnnouncements={allRecentAnnouncements}
            weeklyAnnouncements={weeklyAnnouncements}
            monthlyAnnouncements={monthlyAnnouncements}
            parent_dashboard_initial_loading={parent_dashboard_initial_loading}
          />
        </div>
        <div className="col-lg-9 col-12">
          <StudentDetails 
            studentData={studentData} 
            availablePapers={availablePapers} 
            grades={grades} 
            parent_dashboard_initial_loading={parent_dashboard_initial_loading}
            parent_dashboard_data_loading={parent_dashboard_data_loading}
          />
        </div>
      </div>
    </div>
  );
}
